import React from "react";
import "../Style/Websoftware.css";

import card1Corner from "../assets/card1-corner.png";
import card2Corner from "../assets/card2-corner.png";
import card3Corner from "../assets/card3-corner.png";
import LetsBuild from "./LetsBuild";

const cardData = [
  {
    id: "01",
    title: "Custom Website Development",
    text: "We develop custom websites tailored to your business objectives, brand identity, and customer needs. Our developers create responsive, secure, and scalable websites that provide seamless user experiences across desktops, tablets, and mobile devices while supporting future business growth.",
    cornerImg: card1Corner,
  },
  {
    id: "02",
    title: "Smart Predication",
    text: "Every successful website starts with a well-defined strategy. We analyze your business goals, target audience, and industry requirements to create an effective development roadmap that improves user engagement, streamlines navigation, and maximizes online conversions.",
    cornerImg: card2Corner,
  },
  {
    id: "03",
    title: "Quality Coding",
    text: "Quality is built into every stage of development. We follow coding best practices, cross-browser compatibility standards, responsive design principles, and comprehensive testing to deliver reliable, secure, and high-performing websites that meet modern web standards.",
    cornerImg: card3Corner,
  },
];

function Websoftware() {
  return (
    <section className="ws-section">
      <div className="ws-container">

        <h2 className="ws-title">Your Website Success Is Our Responsibility</h2>
        <p className="ws-subtitle">Modern Development. Scalable Solutions. High Performance.</p>

        <div className="ws-cards">
          {cardData.map((card, index) => (
            <div className="ws-outer" key={index}>

              {/* dot on top border, centered by flexbox */}
              <div className="ws-dot" />

              {/* corner image inside outer, top-right */}
              <img src={card.cornerImg} alt="" className="ws-corner-img" />

              {/* white inner card */}
              <div className="ws-inner">
                <span className="ws-num">{card.id}</span>
                <h3 className="ws-card-title">{card.title}</h3>
                <p className="ws-card-text">{card.text}</p>
              </div>

            </div>
          ))}
        </div>

        <div className="ws-footer">
          <button className="ws-btn"><LetsBuild /> ↗</button>
          {/* <div className="ws-consult">
            <span>Free consultation</span>
            <div className="ws-arrow">↗</div>
          </div> */}
        </div>

      </div>
    </section>
  );
}

export default Websoftware;